import { render, staticRenderFns } from "./xiyi.vue?vue&type=template&id=9ddcdd30&scoped=true&"
import script from "./xiyi.vue?vue&type=script&lang=js&"
export * from "./xiyi.vue?vue&type=script&lang=js&"
import style0 from "./xiyi.vue?vue&type=style&index=0&id=9ddcdd30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddcdd30",
  null
  
)

export default component.exports